import { useEffect } from 'react';
import { Player } from '../../../types';
import usePlayPause from './usePlayPause';

type HookProps = {
  inView: boolean;
  player: Player | null;
  autoplay: boolean;
  playHidden: boolean;

  setShowPoster: (value: boolean) => void;
};

const usePlayInView = ({ inView, player, autoplay, playHidden, setShowPoster }: HookProps) => {
  const [play, pause] = usePlayPause({
    player,
    onRejected: () => setShowPoster(true)
  });

  useEffect(() => {
    if (!player) return;

    const canStartPlay = autoplay && inView && player.source;
    const canStopPlay = player.playing && !inView && !playHidden;

    if (canStartPlay) {
      play();
    } else if (canStopPlay) {
      pause();
    }
  }, [player, inView, playHidden]);
};

export default usePlayInView;
